export default "__VITE_ASSET__CLLBttst__"